// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VCalendar from 'v-calendar';
import Router from 'vue-router';
import 'vue-datetime/dist/vue-datetime.css';
import 'v-calendar/lib/v-calendar.min.css';
import Datetime from 'vue-datetime';
import VueLoading from 'vuex-loading';
import BootstrapVue from 'bootstrap-vue';
import lodash from 'lodash';
import VueLodash from 'vue-lodash';
import { Settings } from 'luxon';
import { sync } from 'vuex-router-sync';
import App from './App';
import router from './router';
import store from './store';
import BaseHttp from './plugins/baseHttp';
import './assets/css/style.css';

Settings.defaultLocale = 'es';
Vue.config.productionTip = false;

Vue.filter('currency', (value => `${parseFloat(value)} €`));
Vue.filter('percentage', (value => `${parseFloat(value)} %`));
Vue.filter('currencyDisplay', {
  read(val) {
    return `$ ${val.toFixed(2)}`;
  },
  write(val) {
    const number = +val.replace(/[^\d.]/g, '');
    return isNaN(number) ? 0 : number;
  },
});

Vue.use(Router);
Vue.use(BootstrapVue);
Vue.use(BaseHttp);
Vue.use(VueLodash, lodash);
Vue.use(Datetime);
Vue.use(VCalendar);
Vue.use(VueLoading);
/* eslint-disable no-new */

const unsync = sync(store, router);

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  vueLoading: new VueLoading({ useVuex: true, moduleName: 'loading' }),
  destroyed() {
    unsync();
  },
});



// WEBPACK FOOTER //
// ./src/main.js